export function getStoredCurrentOrg(storage = localStorage) {
  const raw = storage.getItem('current_org')
  if (!raw) {
    return {}
  }

  try {
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {}
  } catch {
    storage.removeItem('current_org')
    return {}
  }
}
